<div class="distance-measure esri-widget" [class.hidden]="!active || !showDialog">
    <div #header class="distance-measure-header" [class.hidden]="state !== 'measuring' && state !== 'measured'"></div>
    <div #body class="distance-measure-body"></div>
    <div #footer class="distance-measure-footer esri-direct-line-measurement-3d__actions" [class.hidden]="state !== 'measuring' && state !== 'measured'">
        <button class="distance-measure-add-layer esri-button esri-button--secondary"
                [class.btn-disabled]="autolayer || state !== 'measured'"
                (click)="addAsLayer(distanceMeasurement2D.viewModel.measurement, distanceMeasurement2D.viewModel.measurementLabel)">
            Add as Layer
        </button>
    </div>
    <label class="distance-measure-auto-create">
        Auto-create layers
        <input type="checkbox" (change)="autolayer = !autolayer" [checked]="autolayer">
    </label>
</div>
